import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import FloatingHelpButton from "./FloatingHelpButton";
import FloatingConversationsButton from "./FloatingConversationsButton";
import SetupAssistantPopup from "./SetupAssistantPopup";
import TrialBanner from "./TrialBanner";
import AppDiscoveryBanner from "./AppDiscoveryBanner";
import ImpersonationBanner from "./ImpersonationBanner";
import { useSidebar } from "@/contexts/SidebarContext";
import { useImpersonation } from "@/hooks/useImpersonation";

export default function Layout() {
  const { isCollapsed, isMobile } = useSidebar();
  const { isImpersonating } = useImpersonation();

  return (
    <div className="h-screen flex flex-col bg-gray-50 overflow-hidden">
      <ImpersonationBanner />
      <Navbar />
      <div
        className={`flex flex-1 min-h-0 ${
          isImpersonating
            ? "pt-[calc(104px+var(--safe-top))]"
            : "pt-[calc(64px+var(--safe-top))]"
        }`}
      >
        <Sidebar />
        <main
          // `flex flex-col`: las páginas a pantalla completa (Reservas,
          // Conversaciones, Carmen…) se miden con `flex-1` en vez de
          // `h-[calc(100vh-4rem)]`, así descuentan solos lo que ocupen los
          // avisos de arriba. Con el alto fijo, el aviso de suscripción
          // quedaba tapado por la página (23-sep-2026).
          className={`flex-1 min-h-0 overflow-auto p-4 lg:p-8 flex flex-col transition-all duration-300 ${
            isMobile
              ? "ml-0" // En móvil no hay margen
              : isCollapsed
                ? "ml-16"
                : "ml-64"
          }`}
        >
          <TrialBanner />
          <AppDiscoveryBanner />
          <Outlet />
        </main>
      </div>
      <FloatingHelpButton />
      <FloatingConversationsButton />
      <SetupAssistantPopup />
    </div>
  );
}
